import Link from "next/link";
import { LogoRaw } from "@calcom/ui";
import Image from "next/image";

export const Footer = () => {
  return (
    <footer id="experts">
      <div
        style={{
          background: "#F0EEEA",
        }}>
        <div className="container py-14 md:py-14">
          <div className="xs:gap-9 mb-20 grid gap-10 sm:grid-cols-1 sm:gap-9 xl:grid-cols-2 xl:gap-0">
            <div className="flex items-center ">
              <Link href="/">
                <LogoRaw />
              </Link>
            </div>
            <div className="flex gap-10 sm:justify-self-start xl:justify-self-end">
              <Link
                target="_blank"
                className="inline-block"
                href="https://clutch.co/profile/noa-ignite-poland-formerly-making-waves-poland#summary">
                <Image src="/clutch.png" width={80} height={85} alt="Clutch" />
              </Link>
              <Link
                target="_blank"
                href="https://www.greatplacetowork.pl/certyfikowane-firmy-2/noa-ignite-polska-sp-z-o-o">
                <Image src="/gptw.png" width={50} height={85} alt="Great Place To Work Certified" />
              </Link>
              <Link target="_blank" href="https://www.forbes.pl/diamenty/2023/laureaci">
                <Image src="/forbes_diamonds.svg" width={108} height={85} alt="Forbes Diamonds Logo" />
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-10   xl:grid-cols-[2fr_8fr] xl:gap-[400px]">
            <div
              style={{
                color: "#001932",
              }}>
              <h3 className="mb-10 text-2xl font-medium text-inherit">Contact</h3>

              <address className="non-italic mb-10 text-lg font-medium leading-7">
                <Link
                  href="https://www.google.pl/maps/place/Noa+Ignite+UK/@51.5221999,-0.1156551,19z/data=!3m1!4b1!4m6!3m5!1s0x48761b9c358644c5:0x56b27d76d92ddd0d!8m2!3d51.5221999!4d-0.1151079!16s%2Fg%2F11sl31vzkc"
                  target="_blank">
                  <p className="not-italic">10 John St</p>
                  <p className="not-italic">London, WC1N 2EB</p>
                  <p className="mb-4 not-italic">United Kingdom</p>
                </Link>

                <a href="tel:+44 7960 921776" className="block not-italic">
                  +44 7960 921776
                </a>
                <a href="mailto:post.uk@noaignite.com" target="_blank" className="block not-italic">
                  post.uk@noaignite.com
                </a>
              </address>

              <div className="flex gap-5">
                <Link href="https://www.linkedin.com/company/noa-ignite-poland/mycompany/" target="_blank">
                  <Image src="/linkedin.svg" width={35} height={35} alt="LinkedIn Logo" />
                </Link>
                <Link href="https://www.facebook.com/noaignitepoland/" target="_blank">
                  <Image src="/facebook.svg" width={35} height={35} alt="Facebook Logo" />
                </Link>
                <Link href="https://www.youtube.com/@NoAIgnitePoland" target="_blank">
                  <Image src="/youtube.svg" width={35} height={35} alt="Youtube Logo" />
                </Link>
                <Link
                  href="https://clutch.co/profile/noa-ignite-poland-formerly-making-waves-poland#summary"
                  target="_blank">
                  <Image src="/clutch.svg" width={35} height={35} alt="Clutch Logo" />
                </Link>
              </div>
            </div>
            <div>
              <h3 className="mb-10 text-2xl font-medium text-inherit">Partnerships</h3>
              <div className="grid grid-cols-1 gap-10 xl:grid-cols-4">
                <div
                  style={{
                    color: "#001932",
                  }}>
                  <Image src="/microsoft.svg" width={120} height={25} alt="Microsoft Logo" className="mb-5" />
                  <p className="text-lg font-medium text-inherit">
                    As a Microsoft Gold Partner we have proven expertise in implementing Microsoft Azure
                    infrastructure.
                  </p>
                </div>
                <div>
                  <Image src="/aws.svg" width={48} height={30} alt="Microsoft Logo" className="mb-5" />
                  <p className="text-lg font-medium text-inherit">
                    We are a Certified Partner of Amazon Web Services.
                  </p>
                </div>
                <div>
                  <Image
                    src="/optimizely.svg"
                    width={120}
                    height={28}
                    alt="Microsoft Logo"
                    className="mb-5"
                  />
                  <p className="text-lg font-medium text-inherit">
                    We are a Silver Partner of Optimizely with over 30 various certifications.
                  </p>
                </div>
                <div>
                  <Image
                    src="/sanity-logo.png"
                    width={120}
                    height={24}
                    alt="Microsoft Logo"
                    className="mb-5"
                  />
                  <p className="text-lg font-medium text-inherit">
                    NoA Ignite is an Agency Partner of Sanity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container bg-white py-10"
        style={{
          color: "#001932",
        }}>
        <div className="grid gap-8 sm:grid-cols-1 xl:grid-cols-2 xl:gap-0">
          <div className="flex items-end ">
            <Link href="https://www.thenorthalliance.com/" className="inline-block">
              <Image src="/noa-family.svg" width={198} height={20} alt="NoA Ignite Family" />
            </Link>
          </div>
          <div className="flex flex-col gap-2 justify-self-start text-inherit xl:flex-row xl:gap-10 xl:justify-self-end">
            <p>NoA Ignite © 2023</p>
            <Link href="https://noaignite.co.uk/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
